module.exports = __webpack_public_path__ + "static/media/aboutusImg1.8e62c42d.jpeg";